import { BaseXYAxisChartOptions, LegendOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import merge from 'lodash/merge';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import {
    BaseXYAxisChartOptionsImpl,
    BubbleOptionsImpl,
    LegendOptionsImpl,
    MetaInfoOptionsImpl,
} from '../options';

import { HyperSpaceAxisBubbleChartWidgetOptions } from './types';

export class HyperSpaceAxisBubbleChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceAxisBubbleChartWidgetOptions {
    @observable baseXYChartOptions: BaseXYAxisChartOptions = new BaseXYAxisChartOptionsImpl();
    @observable zeroFill = true;
    @observable bubble = new BubbleOptionsImpl();
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable metaInfoOptions = new MetaInfoOptionsImpl();
}
